import { datadogRum } from '@datadog/browser-rum';
import Cookies from 'js-cookie';
import { getUserState } from '@carvana/core-auth';
import { environment } from '../environment';

const BCID = 'BrowserCookieId';

const initDataDog = () => {
  try {
    datadogRum.init({
      applicationId: '4a87058e-c897-415a-bc20-4e52fe2330a9',
      clientToken: 'pubbcc0d48ea496006e9c2abe365aaa4741',
      site: 'datadoghq.com',
      service: 'core-account-ui',
      env: environment,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      defaultPrivacyLevel: 'mask-user-input'
    });

    datadogRum.setUser({
      id: Cookies.get(BCID) || '',
      userId: getUserState().user?.user_id
    });

    datadogRum.startSessionReplayRecording();
  } catch (error) {
    console.error('Failed to initialize DataDog RUM:', error);
  }
};

export default initDataDog;
